/* eslint no-unused-vars:off */
enum ExportType {
  PRODUCTS = "products",
  CATEGORIES = "categories",
}

export default ExportType;
